import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { Base } from "./Base";

export class ListView extends Base {

    public form: FormGroup;
    public fields: FormlyFieldConfig[];
    public model: any = [];

    constructor() 
    {
        super();
        this.form = new FormGroup({});
        this.fields = [];
    }


}
